import Vue from 'vue'
import axios from 'axios'
import utils from './util'
import jumpInApp from './jumpInApp'
import Toast from '@/components/toast/index'
Vue.use(Toast)

Vue.prototype.isLogin = !utils.isApp() && utils.getStorage('localStorage', 'oauth_token') ? true : false
Vue.prototype.baseUrl = window.location.origin
export function addTokenAndKeyParams(options = {}) {
  let base = {}
  if (utils.isApp()) {
    base = {
      oauth_token: utils.getQueryString('oauth_token',location.search.slice(1)),
      appkey: utils.getQueryString('appkey',location.search.slice(1)),
      appSource: 'qxtx'
    }
    
  } else {
    base = {
      oauth_token: process.env.NODE_ENV === 'development' ? 'c43a5519c81db6d8959ba4bac6ba7c202408130101' : utils.getStorage('localStorage', 'oauth_token'),
      appkey: 'kTjxJFdkA1POnvgg',
      appSource: 'qxtx'
    }
  }
  return Object.assign(base, options)
}

const baseOption = {
  timeout: 10000
}
const baseParams = {
  version: '6.0',
  ts: parseInt(new Date().getTime() / 1000)
}

function qs(data) {
  let ret = ''
  const resultData = Object.assign({ ...baseParams }, data || {})
  for (let it in resultData) {
    ret += `${encodeURIComponent(it)}=${encodeURIComponent(resultData[it])}&`
  }
  return ret
}

const http = (options = {}) => {
  const other = options.isFromQxtx ? { appSource: 'qxtx' } : {}
  if (!options.method || options.method.toLowerCase() === 'get') {
    options.params = { ...options.params, ...baseParams, ...other }
  }
  return new Promise((resolve, reject) => {
    axios({
      ...baseOption,
      ...options,
      transformRequest: [
        function(data) {
          return typeof data == 'string' ? data : qs({ ...data, ...other })
        }
      ]
    }).then(
      res => {
        const { data } = res
        //登录失效code则返回登录页
        if (+data.res_code === 4) {
          // todo 跳登录
          if (utils.isApp()) {
            jumpInApp({ case: 34 })
          } else {
            if (options.backUrl) {
              window.location.href = window.location.origin + '/user/phone.html?backUrl=' + options.backUrl
            } else {
              window.location.href = window.location.origin + '/user/phone.html'
            }
          }
          return reject(res.data)
        }
        //请求失败
        if (+data.res_code === 0) {
          Vue.prototype.$toast(data.res_msg, { zIndex: 99999 })
          return reject(data)
        }
        //请求失败
        if (+data.state === 0) {
          console.log(data)
          Vue.prototype.$toast(data.error_message, { zIndex: 99999 })
          return reject(data)
        }
        return resolve(data)
      },
      error => {
        Vue.prototype.$toast(error.data.res_msg)
        return reject(error.data)
      }
    )
  })
}
export default http
     